export class Geocoder {
  geocoder = new google.maps.Geocoder()
  placesService = new google.maps.places.PlacesService(
    document.createElement('div')
  )

  getLocationFromPlaceID = ({ place_id, sessionToken }) => {
    return new Promise((resolve, reject) => {
      this.placesService.getDetails(
        {
          placeId: place_id,
          sessionToken,
          fields: ['address_components', 'geometry']
        },
        (place, placeStatus) => {
          if (placeStatus === 'OK') {
            this.geocoder.geocode(
              {
                location: place.geometry.location
              },
              (geoResults, geoStatus) => {
                const postal_code_result = geoResults.find(
                  el => el.types.indexOf('postal_code') > -1
                )
                const street_address_result = geoResults.find(
                  el => el.types.indexOf('street_address') > -1
                )

                if (
                  geoStatus === 'OK' &&
                  (postal_code_result || street_address_result)
                ) {
                  let components
                  if (postal_code_result) {
                    components = postal_code_result.address_components
                  } else if (street_address_result) {
                    components = street_address_result.address_components
                  }

                  if (!components) {
                    reject()
                  }

                  const locality =
                    place.address_components.find(
                      component => component.types.indexOf('locality') > -1
                    ) ||
                    components.find(
                      component => component.types.indexOf('locality') > -1
                    )

                  const administrative_area_level_2 =
                    place.address_components.find(
                      component =>
                        component.types.indexOf('administrative_area_level_2') >
                        -1
                    ) ||
                    components.find(
                      component =>
                        component.types.indexOf('administrative_area_level_2') >
                        -1
                    )

                  const administrative_area_level_1 =
                    place.address_components.find(
                      component =>
                        component.types.indexOf('administrative_area_level_1') >
                        -1
                    ) ||
                    components.find(
                      component =>
                        component.types.indexOf('administrative_area_level_1') >
                        -1
                    )

                  let city
                  if (locality) {
                    city = locality.long_name
                  } else if (administrative_area_level_2) {
                    city = administrative_area_level_2.long_name
                  } else if (administrative_area_level_1) {
                    city = administrative_area_level_1.long_name
                  }

                  const state = {
                    long_name:
                      administrative_area_level_1 &&
                      administrative_area_level_1.long_name,
                    short_name:
                      administrative_area_level_1 &&
                      administrative_area_level_1.short_name
                  }

                  const postcode = `${
                    components.find(component => {
                      return component.types.indexOf('country') > -1
                    }).short_name
                  }-${
                    (place.address_components.find(
                      component => component.types.indexOf('postal_code') > -1
                    ) &&
                      place.address_components.find(
                        component => component.types.indexOf('postal_code') > -1
                      ).long_name) ||
                    components.find(
                      component => component.types.indexOf('postal_code') > -1
                    ).long_name
                  }`

                  const country = components.find(component => {
                    return component.types.indexOf('country') > -1
                  }).long_name

                  resolve({
                    label: `${postcode} ${city}`,
                    city,
                    postcode,
                    state,
                    country,
                    location: {
                      lat: place.geometry.location.lat(),
                      lng: place.geometry.location.lng()
                    }
                  })
                }

                reject()
              }
            )
          } else {
            reject()
          }
        }
      )
    })
  }

  getLocationFromPostcode = postcode => {
    const [countryCode, postalCode] = postcode.split('-')

    return new Promise((resolve, reject) => {
      this.geocoder.geocode(
        { address: `${postalCode},${countryCode}` },
        (results, status) => {
          if (status === 'OK') {
            const postalCodeResult = results.find(el =>
              el.types.includes('postal_code')
            )

            if (postalCodeResult) {
              const { address_components: components } = postalCodeResult

              const findComponent = type =>
                components.find(component => component.types.includes(type))

              const administrativeAreaLevel1 = findComponent(
                'administrative_area_level_1'
              )
              const state = {
                long_name: administrativeAreaLevel1.long_name,
                short_name: administrativeAreaLevel1.short_name
              }

              const city = findComponent('locality')?.long_name

              const country = findComponent('country')
              const formattedPostcode = `${country.short_name}-${
                findComponent('postal_code').long_name
              }`

              const { lat, lng } = postalCodeResult.geometry.location
              const latitude = typeof lat === 'function' ? lat() : lat
              const longitude = typeof lng === 'function' ? lng() : lng

              resolve({
                label: `${formattedPostcode} ${city}`,
                city,
                postcode: formattedPostcode,
                state,
                country: country.long_name,
                location: {
                  lat: latitude,
                  lng: longitude
                }
              })
            } else {
              reject(
                new Error(
                  'Unable to find a postal code in the provided address.'
                )
              )
            }
          } else {
            reject(new Error(`Geocoding failed with status: ${status}`))
          }
        }
      )
    })
  }
}

export default Geocoder
